"use client"
import { ComponentConfig } from "@measured/puck"
import { Button, Modal } from "antd"
import { useState } from "react"
import { configs, DefaultImage, Media, MediaUpload } from "../../../../external-components"
import { commonStylesProps } from "../../../lib/commonCSSProps"
import getClassNameFactory from "../../../lib/get-class-name-factory"
import styles from "./css/styles.module.css"
import { RenderConfig, SimpleSliderProps } from "./RenderConfig"

const getClassName = getClassNameFactory("SimpleSlider", styles)

const SlideItem = ({ value, onChange }: any) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isChooseMedia, setIsChooseMedia] = useState(true)
  const [url, setUrl] = useState(value)

  const openModal = () => {
    setIsModalOpen(true)
  }

  const handleSelectMedia = (media: { url: string }) => {
    setUrl(media.url)
    onChange(media.url)
    setIsModalOpen(false)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
  }

  return (
    <div className={getClassName("imageInput")}>
      <div className="flex flex-col gap-2">
        <input type="text" value={url} onChange={e => onChange(e.target.value)} placeholder="Image URL" readOnly />
        <div className="relative cursor-pointer group" onClick={() => openModal()}>
          <img
            src={url ? `${configs.API_URL}${url}` : DefaultImage}
            alt="Image"
            className={`${getClassName(
              "imagePreview",
            )} rounded-lg max-h-96 cursor-pointer transition duration-300 ease-in-out group-hover:blur-sm overflow-hidden`}
          />
          <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition duration-300 ease-in-out">
            <span className="text-white text-3xl font-semibold drop-shadow-md">Change media</span>
          </div>
        </div>

        <Button
          onClick={() => openModal()}
          type="default"
          variant="outlined"
          className="bg-blue text-white p-4 border-[1px] border-blue rounded-[3px] hover:bg-blue-800 hover:text-white duration-300 my-2"
        >
          Select Image
        </Button>
      </div>

      <Modal
        open={isModalOpen}
        title={<span className="ml-4">Select Media</span>}
        onCancel={handleCloseModal}
        style={{ top: 20 }}
        width="95%"
        footer={null}
      >
        <div className="ml-4 mt-5">
          <Button
            onClick={() => setIsChooseMedia(true)}
            className="mr-2"
            style={{
              backgroundColor: isChooseMedia ? "blue" : "initial",
              color: isChooseMedia ? "white" : "initial",
            }}
          >
            Select Media
          </Button>
          <Button
            onClick={() => setIsChooseMedia(false)}
            style={{
              backgroundColor: !isChooseMedia ? "blue" : "initial",
              color: !isChooseMedia ? "white" : "initial",
            }}
          >
            Upload Media
          </Button>
        </div>
        <div>
          {isChooseMedia ? (
            <Media isOpenModal={true} onSelectMedia={handleSelectMedia} />
          ) : (
            <MediaUpload isOpenModal={true} setChooseMedia={setIsChooseMedia} />
          )}
        </div>
      </Modal>
    </div>
  )
}

export const GameSlider: ComponentConfig<SimpleSliderProps> = {
  label: "Simple Slider",
  //@ts-ignore
  fields: {
    slides: {
      label: "Slides",
      type: "array",
      getItemSummary: (slides, index = 0) => `Slide: ${index}`,
      arrayFields: {
        image: {
          label: "Image",
          type: "custom",
          render: props => <SlideItem {...props} />,
        },
        url: {
          label: "Link",
          type: "text",
        },
        titleSlideItem: {
          label: "Title",
          type: "text",
        },
      },
    },
    // imageHeight: {
    //   label: "Image Height (px)",
    //   type: "number",
    //   min: 0,
    // },
    // imageWidth: {
    //   label: "Image Width (px)",
    //   type: "number",
    //   min: 0,
    // },
    imageBorderRadius: {
      label: "Image Border Radius (px)",
      type: "number",
      min: 0,
    },
    spaceBetween: {
      label: "Space Between Slides (px)",
      type: "number",
      min: 0,
    },
    slidesPerView: {
      label: "Slides Per View",
      type: "number",
      min: 1,
    },
    loop: {
      label: "Loop",
      type: "select",
      options: [
        { label: "Yes", value: true },
        { label: "No", value: false },
      ],
    },
    autoPlay: {
      label: "Auto Play",
      type: "select",
      options: [
        { label: "Yes", value: true },
        { label: "No", value: false },
      ],
    },
    speed: {
      label: "Speed (ms)",
      type: "number",
      min: 0,
    },
    timeDelay: {
      label: "Time Delay (ms)",
      type: "number",
      min: 0,
    },
    isPagination: {
      label: "Show Pagination",
      type: "select",
      options: [
        { label: "Yes", value: true },
        { label: "No", value: false },
      ],
    },
    pagination: {
      label: "Pagination",
      type: "select",
      options: [
        { label: "Default", value: "default" },
        { label: "Custom", value: "custom" },
      ],
    },

    isNavigation: {
      label: "Show Navigation",
      type: "select",
      options: [
        { label: "Yes", value: true },
        { label: "No", value: false },
      ],
    },
    ...commonStylesProps,
  },
  defaultProps: {
    slides: [
      {
        id: 1,
        image: "/uploads/Icon_512x512_HyperRun.webp",
        url: "/games",
      },
      {
        id: 2,
        image: "/uploads/Icon_512x512_Merge_game.webp",
        url: "/games",
      },
      {
        id: 3,
        image: "/uploads/MMR_icon.webp",
        url: "/games",
      },
      {
        id: 4,
        image: "/uploads/b384d5_06f16e098b73451ebffa13b7d8a73a8b~mv2_4_11zon.webp",
        url: "/games",
      },
      {
        id: 5,
        image: "/uploads/b384d5_1cf121544791408d97347cde7d016110~mv2_2_11zon.webp",
        url: "/games",
      },
      {
        id: 6,
        image: "/uploads/b384d5_43a6215ad8b749f9923f9405d5c1ed25~mv2_3_11zon.webp",
        url: "/games",
      },
      {
        id: 7,
        image: "/uploads/b384d5_53f1e9763ce84502a7fb63b925ad75f2~mv2_5_11zon.webp",
        url: "/games",
      },
      {
        id: 8,
        image: "/uploads/b384d5_6a8981e8869740ae837bfbd9b98e4a14~mv2_6_11zon.webp",
        url: "/games",
      },
      {
        id: 9,
        image: "/uploads/b384d5_f2f1d1372eb9473c835ce9733a3ea3b5~mv2_1_11zon.webp",
        url: "/games",
      },
      {
        id: 10,
        image: "/uploads/doge_1024x1024.webp",
        url: "/games",
      },
      {
        id: 11,
        image: "/uploads/icon_1024x1024_2.webp",
        url: "/games",
      },
      {
        id: 12,
        image: "/uploads/icon_512x512.webp",
        url: "/games",
      },
      {
        id: 13,
        image: "/uploads/icon_512x512_Jewels.webp",
        url: "/games",
      },
      {
        id: 14,
        image: "/uploads/icon_pourwater.webp",
        url: "/games",
      },
      {
        id: 15,
        image: "/uploads/icon_tanglegame.webp",
        url: "/games",
      },
      {
        id: 16,
        image: "/uploads/tap-escape.webp",
        url: "/games",
      },
      {
        id: 17,
        image: "/uploads/tile-animal.webp",
        url: "/games",
      },
      {
        id: 18,
        image: "/uploads/tile-connect.webp",
        url: "/games",
      },
      {
        id: 19,
        image: "/uploads/tile-link.webp",
        url: "/games",
      },
      {
        id: 20,
        image: "/uploads/tile-zen.webp",
        url: "/games",
      },
      {
        id: 21,
        image: "/uploads/toy-master.webp",
        url: "/games",
      },
      {
        id: 22,
        image: "/uploads/toy-triple.webp",
        url: "/games",
      },
      {
        id: 23,
        image: "/uploads/zen-triple.webp",
        url: "/games",
      },
    ],
    spaceBetween: 30,
    slidesPerView: 1,
    autoPlay: true,
    speed: 600,
    timeDelay: 3500,
    isPagination: true,
    isNavigation: true,
    loop: true,
    pagination: "default",
    className: "",
    styles: {
      mobile: {
        display: "block",
      },
      tablet: {
        display: "block",
      },
      desktop: {
        display: "block",
      },
    },
  },
  ...RenderConfig,
}
